import React from "react";
import { STEPS } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function HowItWorks() {
  const r = useReveal();
  return (
    <section id="how" className="bg-ls py-20 md:py-28">
      <div ref={r.ref} className={`max-w-7xl mx-auto px-5 md:px-8 ${r.className}`}>
        <p className="ls-eyebrow mb-4">How it works</p>
        <h2 className="font-display text-white text-[10vw] sm:text-5xl md:text-6xl mb-14">
          Three steps. <span className="text-orange">That's it.</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-6">
          {STEPS.map((s) => (
            <div key={s.n} className="card-dark p-8 relative overflow-hidden">
              <span className="font-display text-[120px] leading-none text-white/5 absolute -top-4 right-2 select-none">
                {s.n}
              </span>
              <span className="big-index text-5xl">{s.n}</span>
              <h3 className="font-cond font-extrabold text-2xl md:text-3xl text-white uppercase tracking-wide mt-4">
                {s.title}
              </h3>
              <p className="mt-3 text-[#b7ab9b] leading-relaxed relative z-10">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
